import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Send } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KindleHistorySection } from "@/components/kindle/history-page";
import { KindleCard } from "@/components/kindle/kindle-card";
import { Page } from "@/components/page";
import { EmptyState, LoadingState } from "@/components/states";
import { featuresQuery } from "@/lib/metadata";

export const Route = createFileRoute("/_app/settings/kindle")({
  component: KindlePage,
});

/** The Kindle address followed by the delivery history. */
function KindlePage() {
  const { t } = useTranslation("kindle");
  const features = useQuery(featuresQuery);
  const configured = features.data?.email.configured ?? false;
  return (
    <Page title={t("page.title")} width={configured ? "full" : "narrow"}>
      {features.isPending ? (
        <LoadingState />
      ) : features.isError ? (
        <p role="alert" className="text-destructive">
          {t("page.loadError")}
        </p>
      ) : configured ? (
        <>
          <div className="max-w-2xl">
            <KindleCard />
          </div>
          <KindleHistorySection />
        </>
      ) : (
        <EmptyState icon={Send} title={t("page.notAvailable")} />
      )}
    </Page>
  );
}
